<template>
  <div class="web-message-container">
    <basic-form
      ref="basicForm"
      :form-data="formData"
    >
      <template #brush_infoList>
        <a-textarea
          v-decorator="['brush_infoList',{rules: [
            { required: false, message: '请输入标签名称' },
          ],}]"
          placeholder="请输入文章评论内容"
          :rows="8"
        />
        <div>多个用英文逗号来分隔,"|"</div>
      </template>
      <template #video_infoList>
        <a-textarea
          v-decorator="['video_infoList',{rules: [
            { required: false, message: '请输入标签名称' },
          ],}]"
          placeholder="请输入视频评论内容"
          :rows="8"
        />
        <div>多个用英文逗号来分隔,"|"</div>
      </template>

      <template #task_infoList>
        <a-textarea
          v-decorator="['task_infoList',{rules: [
            { required: false, message: '请输入标签名称' },
          ],}]"
          placeholder="请输入签名名称"
          :rows="8"
        />
        <div>多个用英文逗号来分隔,"|"</div>
      </template>
    </basic-form>
    <div class="btn-container">
      <a-button
        :loading="btnIsLoading"
        type="primary"
        style="margin-left:20px;"
        @click="$emit('handleSubmit')"
      >
        保存
      </a-button>
    </div>
  </div>
</template>
<script>
import { formDataComment } from '../data/index';
export default {
  props: ['btnIsLoading'],
  data() {
    return {
      formData: formDataComment,
    };
  },
  mounted() {},

};
</script>
<style lang="scss" scoped>
.web-message-container {
.btn-container{
  text-align: right;
}
}
</style>